import { BaseApiService } from './base.service';
import { ImportResponse } from '../../types/api';

export interface ValidationResponse {
  valid: boolean;
  errors: string[];
  warnings: string[];
  missing_server_info: boolean;
  summary: string;
  validation_details: string;
}

/**
 * Service for data import operations
 */
export class ImportService extends BaseApiService {
  async importControllerJson(serverId?: number): Promise<ImportResponse> {
    const params = serverId ? `?server_id=${serverId}` : '';
    return this.post(`/api/v1/import/controller-json${params}`);
  }

  async importSupervisorJson(serverId?: number): Promise<ImportResponse> {
    const params = serverId ? `?server_id=${serverId}` : '';
    return this.post(`/api/v1/import/supervisor-json${params}`);
  }

  async importCurrentSupervisorJson(serverId?: number): Promise<ImportResponse> {
    const params = serverId ? `?server_id=${serverId}` : '';
    return this.post(`/api/v1/import/current-supervisor-json${params}`);
  }

  async importFile(file: File, serverId?: number): Promise<ImportResponse> {
    const formData = new FormData();
    formData.append('file', file);
    
    const params = serverId ? `?server_id=${serverId}` : '';
    const response = await this.axiosInstance.post<ImportResponse>(`/api/v1/import/file${params}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    
    return response.data;
  }

  async importViaWebhook(data: any, serverId?: number): Promise<ImportResponse> {
    const params = serverId ? `?server_id=${serverId}` : '';
    return this.post(`/api/v1/import/webhook${params}`, data);
  }

  async validateData(data: any, serverId?: number): Promise<ValidationResponse> {
    const params = serverId ? `?server_id=${serverId}` : '';
    return this.post(`/api/v1/import/validate${params}`, data);
  }

  async validateFile(file: File, serverId?: number): Promise<ValidationResponse> {
    const formData = new FormData();
    formData.append('file', file);
    
    const params = serverId ? `?server_id=${serverId}` : '';
    const response = await this.axiosInstance.post<ValidationResponse>(`/api/v1/import/validate-file${params}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    
    return response.data;
  }
}

export const importService = new ImportService();